import { render } from "./QC4AreaRetention.vue?vue&type=template&id=ff193712"
import script from "./QC4AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC4AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC4AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff193712"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff193712', __exports__)) {
    console.log('reload')
    api.reload('ff193712', __exports__)
  }
  
  module.hot.accept("./QC4AreaRetention.vue?vue&type=template&id=ff193712", () => {
    console.log('re-render')
    api.rerender('ff193712', render)
  })

}


export default __exports__